import React, {FC} from 'react';

/** 에이전트 제도 한국어 본문(i18n: 셸 컴포넌트가 언어에 따라 zh/en/ko 콘텐츠 컴포넌트를 선택; h1은 셸 hero에 있고 본문은
 * h2부터 시작, 요소 구조는 zh.tsx와 1:1 대응, 타이포그래피는 Prose(.v3-prose)가 제공). 2026-09-17 AI 번역. */
const KoContent: FC = () => {
  return (
    <>
      <section>
        <h2>에이전트 제도란?</h2>
        <p>
          더 많은 크로스보더 콘텐츠 현지화 수요를 가진 판매자를 지원하고, Xiangji를 동료 판매자에게 소개해 주는 성실한
          사용자께 보답하고자 Xiangji는 에이전트 제도를 시작했습니다. 상품 이미지 생성, 영상 현지화, 메인·상세 이미지
          생성이 필요한 크로스보더 사업을 운영하는 지인에게 개인 추천 링크를 공유하기만 하면 됩니다. 지인이 Xiangji
          사용자로 가입한 뒤에는 이후 모든 결제 건에 대해 추천 리워드가 지급되며, 영구적이고 만료 기한이 없고 다시
          초대할 필요도 없습니다.
        </p>
        <div className="v3-note">
          <p>
            이 제도는 모든 Xiangji 사용자에게 개방되어 있으며 별도의 자격 요건이나 승인이 필요하지 않습니다. 가입하는
            순간 이미 본인의 추천 링크가 발급되어 언제든지 공유할 수 있습니다.
          </p>
        </div>
      </section>
      <section>
        <h2>리워드 규칙</h2>
        <p>
          지인이 추천 링크를 통해 가입하고 결제를 완료하면, 결제 건마다 아래 두 가지 리워드 옵션 중 하나를 선택하실 수
          있습니다. 두 옵션은 상호 배타적이며 결제 건별로 정산됩니다:
        </p>
        <ul>
          <li>
            <strong>15% 크레딧 리워드</strong>: 지인의 결제 금액을 동일한 금액의 Xiangji 서비스 크레딧으로 전환하여 본인
            계정에서 이미지 생성, 영상 현지화, 상품 등록 콘텐츠 생성에 바로 사용하실 수 있습니다. 본인이 Xiangji를
            활발하게 사용하는 사용자라면 가장 적합합니다;
          </li>
          <li>
            <strong>10% 현금 리베이트</strong>: 현금으로 바로 지급됩니다. 즉시 수익을 선호하신다면 가장 적합합니다.
          </li>
        </ul>
        <p>
          예를 들어: Xiangji 사용자인 라오왕(老王)에게는 크로스보더 전자상거래 사업을 시작하며 상품 이미지 생성과 상품
          등록 콘텐츠 서비스가 필요한 절친 샤오리(小李)가 있습니다. Xiangji가 저렴한 가격에 좋은 결과를 낸다고 믿은
          라오왕은 샤오리에게 자신의 추천 링크를 공유했습니다. 샤오리가 가입한 뒤 이미지 크레딧 10,000개를 구매하면,
          라오왕은 <strong>15% 크레딧 리워드</strong>(이미지 크레딧 1,500개) 또는 <strong>10% 현금 리베이트</strong>를
          선택하실 수 있습니다.
        </p>
      </section>
      <section>
        <h2>에이전트가 되는 방법</h2>
        <h3>1. 개인 추천 링크 받기</h3>
        <p>
          Xiangji 워크스페이스에 로그인한 뒤 계정 센터에서 본인의 개인 추천 링크를 확인하실 수 있습니다. 링크는 계정에
          영구적으로 귀속됩니다.
        </p>
        <img
          alt="추천 링크 페이지"
          decoding="async"
          loading="lazy"
          src="https://www.xiangjifanyi.com/doc/assets/images/proxyLink-b19297b66a83019a38381eedec4e6a15.jpg"
        />
        <h3>2. 해외 진출을 준비하는 판매자 지인에게 링크 보내기</h3>
        <p>
          지인은 휴대폰 번호로 가입하면 됩니다. 추천 코드를 직접 입력할 필요 없이 시스템이 자동으로 추천 관계를 연결해
          줍니다.
        </p>
        <h3>3. 언제든지 “사용자 목록”에서 추천 현황과 리워드 확인하기</h3>
        <p>
          지인이 가입하면 워크스페이스의 “사용자 목록”에서 모든 추천 고객을 확인하실 수 있으며, 결제 내역과 리워드 지급
          현황을 추적하실 수 있습니다.
        </p>
        <img
          alt="추천 고객 목록 페이지"
          decoding="async"
          loading="lazy"
          src="https://www.xiangjifanyi.com/doc/assets/images/customerList-6a1f51325e636766f7270d307f93568b.jpg"
        />
      </section>
    </>
  );
};

export default KoContent;
